import { FC, CSSProperties } from 'react';
import { Tooltip, useTheme } from '@material-ui/core';
import RemoveOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import { IconLabelBox } from '../../IconLabelBox';
import { NotStartedIcon as NotStarted } from './Icons';
import { useStyles } from './style';

interface Props {
  style?: CSSProperties;
  variant?: 'reduced' | 'default';
}

export const NotStartedIcon: FC<Props> = ({ style, variant = 'default' }) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Tooltip title="At least one error was encountered in this execution due to a previous policy, so this check was not executed at all">
      <span>
        {variant === 'reduced' ? (
          <NotStarted className={`${classes.icon}`} style={style} />
        ) : (
          <IconLabelBox
            label="Not Started"
            backgroundColor={theme.palette.blueGrey[200]}
            icon={
              <RemoveOutlineIcon
                style={style}
                htmlColor={theme.palette.black}
              />
            }
          />
        )}
      </span>
    </Tooltip>
  );
};
